import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog'

/* shown instead of a redirect: the invoice opens in a second tab, so this page
 * stays mounted and picks up the paid broadcast without a refresh. */
export function InvoiceSentDialog({
  open,
  onOpenChange,
  email,
  invoiceUrl
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  email: string | null
  invoiceUrl: string | null
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='sm:max-w-[440px]'>
        <DialogHeader>
          <DialogTitle>Your invoice is ready</DialogTitle>
          {/* the email rides the invoice.finalized webhook, so it lands a moment
              after this dialog. promising it in the past tense sent people to
              an inbox before it arrived. */}
          <DialogDescription>
            {email
              ? `We are sending it to ${email}. You can pay it now, or from the Billing page whenever you are ready. Your plan starts once it is paid.`
              : 'You can pay it now, or from the Billing page whenever you are ready. Your plan starts once it is paid.'}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant='outline' onClick={() => onOpenChange(false)}>
            Close
          </Button>
          {invoiceUrl && (
            <Button
              onClick={() => window.open(invoiceUrl, '_blank', 'noopener')}
            >
              Pay now
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
